import { AfterViewInit, Component, HostListener, OnInit } from '@angular/core';
import { NavigationStart, Router, RouterOutlet } from '@angular/router';
import { Urls } from '@core/config/urls';
import { ThemeService } from '@core/services';
import { LanguageService, StorageKeys } from '@smartera/core';
import { LoadingService } from '@smartera/core';
import { LocalStorageService, SessionStorageService } from '@smartera/core';
import { LoginDialogService } from '@core/services/login-dialog.service';
import { ThemeColorService } from '@core/services/theme-color.service';
import { UtilityService } from '@core/services/utility.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { PrimeNG } from 'primeng/config';
import { PrimengModule } from '@modules/primeng/primeng.module';
import { LoaderModule } from '@shared/components';
import { environment } from '../environments/environment';
import { fade } from '@smartera/animations';

@Component({
	standalone: true,
	selector: 'app-root',
	imports: [RouterOutlet, TranslateModule, PrimengModule, LoaderModule],
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss'],
	animations: [fade],
})
export class AppComponent implements OnInit, AfterViewInit {
	public theme = 'nova-dark';

	public state;

	constructor(
		private _languageService: LanguageService,
		public loadingService: LoadingService,
		public router: Router,
		public loginloader: LoadingService,
		public _themeColorService: ThemeColorService,
		public utilServ: UtilityService,
		public loginDialogService: LoginDialogService,
		private config: PrimeNG,
		private translateService: TranslateService,
		private localStorageService: LocalStorageService,
		private sessionStorageService: SessionStorageService,
		private themeService: ThemeService
	) {
		Urls.BASE_URL = environment.baseURL;
		/**
		 * Bir tab açıldığında AppComponent contructor'ı çalışacağı için burada her tab için sessionStorage'da tutulacak bir tabHash bilgisi tutuyoruz.
		 */
		const tabHash = 'tab_' + new Date().getTime().toString();
		this.sessionStorageService.setItem(StorageKeys.TAB_HASH, tabHash);
		const tabsOpen = JSON.parse(this.localStorageService.getItem(StorageKeys.OPEN_TABS) || '{}');
		tabsOpen[tabHash] = true;
		this.localStorageService.setItem(StorageKeys.OPEN_TABS, JSON.stringify(tabsOpen));
	}

	public ngOnInit(): void {
		this.translateService.get('primeng').subscribe((res) => this.config.setTranslation(res));

		this.router.events.subscribe((e) => {
			if (e instanceof NavigationStart) {
				this.loginloader.isLoading = true;
			}
		});
	}

	public ngAfterViewInit(): void {
		try {
			const fontSize = localStorage.getItem('fontSize') || 'f-normal';
			document.querySelector('#main').className = fontSize;
		} catch {}
	}

	@HostListener('window:beforeunload', ['$event'])
	beforeUnloadHandler(event) {
		const tabHash = this.sessionStorageService.getItem(StorageKeys.TAB_HASH);
		const tabsOpen = JSON.parse(this.localStorageService.getItem(StorageKeys.OPEN_TABS) || '{}');
		delete tabsOpen[tabHash];
		this.localStorageService.setItem(StorageKeys.OPEN_TABS, JSON.stringify(tabsOpen));
	}
}
